/*
	Site IDs are Sherlock fields used to categorise properties. 
*/

Site_ids = {
	// Find check inputs for the Site ID details UI
	p_input_element : {}
	,
	// Find hidden element which tracks the active Site ID details. Holds comma delimited list of FD titles.
	p_tracking_element : {}
	,
	init : function()
	{
		// Set properties.
		Site_ids.p_input_element = jQuery('.property-search .oc-site-id');
		Site_ids.p_tracking_element = jQuery('input[name="property_site_id"]');
		
		// Setup UI.
		Site_ids.setup_ui();
	}
	,
	setup_ui : function()
	{
		// Set check elements to trigger events on change.
		Site_ids.p_input_element.change(function(){
			
			// Set parent element to reflect checked state via class.
			var parent_element = jQuery(this).closest('.form-check');
			
			if( jQuery(this).is(':checked') )
			{
				parent_element.addClass('checked');
			}
			else
			{
				parent_element.removeClass('checked');
			}
			
			// Reset tracking list upon check element update.
			var options = {};
			Site_ids.p_tracking_element.trigger('sh_property_search_site_id_update',options);
			
		});
		
		// Set tracking element to react to check elements updates.
		// Tracking element holds comma delimited list of Feature titles.
		Site_ids.p_tracking_element.on('sh_property_search_site_id_update',function(event,pm_options){
			
			// Empty tracking list.
			jQuery(this).val('');
			
			// Iterate through check elements and add checked values to tracking list. 
			var site_ids = '';
			Site_ids.p_input_element.each(function(pm_index){
				var sep = (site_ids == '') ? '' : '+';
				if( jQuery(this).is(':checked') )
				{
					site_ids += sep + jQuery(this).val();
				}
			});
			
			// Fill tracking list with new value.
			jQuery(this).val(site_ids);
			
		});
	}
}

// Select field in search form allowing selection of Site ID categories.
Site_ids_select =
{
	// Path to our page element for jQuery.
	p_element_id : {}
	,
	init : function()
	{
		// Set properties.
		Site_ids_select.p_element_id = jQuery( '[data-oc-id="site-id-select"]' );
		
		// Check if region search elements are on page.
		if( Site_ids_select.p_element_id.size() == 0 )
		{
			return false;
		}
		
		// Setup UI.
		Site_ids_select.init_ui();
	}
	,
	init_ui : function()
	{
		var select = Site_ids_select.p_element_id;
		
		select.change(function(){
			var value = select.find('select').val();
			
			// Emit event. Change Site ID.
			var options = {};
			options.site_ids = value;
			jQuery(document).trigger('oc_property_search_site_id_update',options);
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	Site_ids.init();
	Site_ids_select.init();

});